export const MEMBER_ROLES = Object.freeze({
  SUPER_ADMIN: 'super_admin',
  OWNER_ADMIN: 'owner_admin',
  SETTER: 'setter',
  CLOSER: 'closer',
  VIEWER_PLUS: 'viewer_plus',
  VIEWER: 'viewer',
});

export const SALES_ROLES = new Set([MEMBER_ROLES.SETTER, MEMBER_ROLES.CLOSER]);
export const ADMIN_ROLES = new Set([MEMBER_ROLES.SUPER_ADMIN, MEMBER_ROLES.OWNER_ADMIN]);
export const ADMIN_VIEW_ROLES = new Set([MEMBER_ROLES.SUPER_ADMIN, MEMBER_ROLES.OWNER_ADMIN, MEMBER_ROLES.VIEWER_PLUS]);
export const OPERATIONAL_ROLES = new Set(Object.values(MEMBER_ROLES));
export const READ_ONLY_ROLES = new Set([MEMBER_ROLES.VIEWER_PLUS, MEMBER_ROLES.VIEWER]);
export const MUTATING_ROLES = new Set([
  MEMBER_ROLES.SUPER_ADMIN,
  MEMBER_ROLES.OWNER_ADMIN,
  MEMBER_ROLES.SETTER,
  MEMBER_ROLES.CLOSER,
]);

export function canUseOperationalCrm(role) {
  return OPERATIONAL_ROLES.has(role);
}

export function canMutateCrm(role) {
  return MUTATING_ROLES.has(role);
}

export function isViewer(role) {
  return READ_ONLY_ROLES.has(role);
}

export function isViewerPlus(role) {
  return role === MEMBER_ROLES.VIEWER_PLUS;
}

// Operational roles can see the same business reporting surface.
// Report access is not admin access.
export function canSeeReports(role) {
  return OPERATIONAL_ROLES.has(role);
}

export function canSeeFullBusinessReports(role) {
  return OPERATIONAL_ROLES.has(role);
}

export function canTrashLead(role) {
  return MUTATING_ROLES.has(role);
}

export function canRevert(role) {
  return MUTATING_ROLES.has(role);
}

export function canManageTeam(role) {
  return ADMIN_ROLES.has(role);
}

// Viewer Plus can inspect non-Super-Admin administrative surfaces but cannot mutate them.
export function canSeeAdmin(role) {
  return ADMIN_VIEW_ROLES.has(role);
}

// Super Admin is the top hierarchy and the only role allowed to grant or
// manage administrative hierarchy access.
export function canManageAdminHierarchy(role) {
  return role === MEMBER_ROLES.SUPER_ADMIN;
}

export function hasCompleteAccess(role) {
  return role === MEMBER_ROLES.SUPER_ADMIN;
}
